import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Typography } from '@mui/material';

import Banner from '../Banner';

const Toast = (message, type = '', position = toast.POSITION.BOTTOM_LEFT, children) => {
  let severity = type || 'info';
  if (type === 'warn') {
    severity = 'error';
  }
  const content = (
    <Banner severity={severity}>
      <Typography variant="body2" sx={theme => ({ fontFamily: theme.typography.bold.fontFamily })}>
        {message}
      </Typography>
      {children}
    </Banner>
  );

  toast(content, {
    className: 'toast',
    closeButton: false,
    position,
    autoClose: 5000,
    hideProgressBar: true,
  });
};

export default Toast;
